import axios, { AxiosInstance } from "axios";
import { setupSecureInterceptors } from "./tokenManager";
import { getRequestScopeHeaders } from "./requestScope";

export const createNewInstance = (BASE_URL: string): AxiosInstance => {
  const instance = axios.create({
    baseURL: BASE_URL,
    headers: getRequestScopeHeaders(),
  });
  return setupSecureInterceptors(instance);
};

export const rag_v2 = createNewInstance(window.env.REACT_APP_RAG_API_URL_V2);
export const rag_v1 = createNewInstance(window.env.REACT_APP_RAG_API_URL);

type ConversationRequestScope = {
  organizationId: string | null;
  projectId: string | null;
};

export const uploadDocument = async (
  conversationId: string,
  file: File,
  requestScope?: ConversationRequestScope,
) => {
  const formData = new FormData();
  formData.append("file", file);
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      ...getRequestScopeHeaders(requestScope),
    },
    ...(requestScope === undefined ? {} : { requestScope }),
  };
  const response = await rag_v2.post(
    `/conversations/${conversationId}/documents`,
    formData,
    config as any,
  );
  return response.data;
};

export const getDocuments = async (
  conversationId: string,
  requestScope?: ConversationRequestScope,
) => {
  const url = `/conversations/${conversationId}/documents`;
  const response =
    requestScope === undefined
      ? await rag_v2.get(url)
      : await rag_v2.get(url, { requestScope } as any);
  return response.data;
};

export const deleteDocument = async (
  conversationId: string,
  documentId: string,
  requestScope?: ConversationRequestScope,
) => {
  const url = `/conversations/${conversationId}/documents/${documentId}`;
  const response =
    requestScope === undefined
      ? await rag_v2.delete(url)
      : await rag_v2.delete(url, { requestScope } as any);
  return response.data;
}
